class DeliveryTimer {
  constructor(el) {
    this.el = el;
    this.cutoff = parseInt(el.dataset.cutoff, 10) || 14;
    this.weekendDelivery = el.dataset.weekend === 'true';
    this.msgEl = el.querySelector('.delivery-timer__message');
    this.countdownEl = el.querySelector('.delivery-timer__countdown');
    this.timeEl = el.querySelector('.delivery-timer__time');
    this.interval = null;
    this.update();
  }

  getPolandTime() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
  }

  isDeliveryDay(date) {
    const d = date.getDay();
    if (this.weekendDelivery) return true;
    return d !== 0 && d !== 6;
  }

  getNextDeliveryDate(now) {
    const hour = now.getHours();
    const beforeCutoff = hour < this.cutoff;

    let shipDate = new Date(now);
    shipDate.setHours(0, 0, 0, 0);

    if (!beforeCutoff) {
      shipDate.setDate(shipDate.getDate() + 1);
      while (!this.isDeliveryDay(shipDate)) {
        shipDate.setDate(shipDate.getDate() + 1);
      }
    }

    let deliveryDate = new Date(shipDate);
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    while (!this.isDeliveryDay(deliveryDate)) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    return deliveryDate;
  }

  formatDayText(deliveryDate, now) {
    const todayMidnight = new Date(now);
    todayMidnight.setHours(0, 0, 0, 0);
    const deliveryMidnight = new Date(deliveryDate);
    deliveryMidnight.setHours(0, 0, 0, 0);
    const diff = Math.round((deliveryMidnight - todayMidnight) / 86400000);

    if (diff === 1) return 'jutro';
    if (diff === 2) return 'pojutrze';
    const names = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];
    return names[deliveryDate.getDay()];
  }

  formatCountdown(now) {
    const cutoff = new Date(now);
    cutoff.setHours(this.cutoff, 0, 0, 0);
    const diff = cutoff - now;
    if (diff <= 0) return null;
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(h)} godz. : ${pad(m)} min : ${pad(s)} sek`;
  }

  update() {
    const now = this.getPolandTime();
    const beforeCutoff = now.getHours() < this.cutoff;
    const deliveryDate = this.getNextDeliveryDate(now);
    const dayText = this.formatDayText(deliveryDate, now);

    if (beforeCutoff) {
      this.msgEl.textContent = `Zamów do ${this.cutoff}:00 a paczka trafi do Ciebie ${dayText}.`;
      const countdown = this.formatCountdown(now);
      if (countdown) {
        this.countdownEl.removeAttribute('hidden');
        this.timeEl.textContent = countdown;
        if (!this.interval) {
          this.interval = setInterval(() => this.update(), 1000);
        }
      } else {
        this.countdownEl.setAttribute('hidden', '');
        clearInterval(this.interval);
        this.interval = null;
      }
    } else {
      this.msgEl.textContent = `Paczka trafi do Ciebie ${dayText}.`;
      this.countdownEl.setAttribute('hidden', '');
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}

document.querySelectorAll('.delivery-timer').forEach((el) => new DeliveryTimer(el));
